import { useState } from 'react';
import { IPoiItem } from '../../../domain/models/IPoiItem';

export const POI_CARDS_PER_PAGE = 16;

export const usePagination = (data: IPoiItem[]) => {
	const [currentPageIndex, setCurrentPageIndex] = useState(0);

	const startIndex = currentPageIndex * POI_CARDS_PER_PAGE;
	const endIndex = startIndex + POI_CARDS_PER_PAGE;
	const slicedPoiData = data.slice(startIndex, endIndex);
	const totalPages = Math.ceil(data.length / POI_CARDS_PER_PAGE);

	return { slicedPoiData, totalPages, currentPageIndex, setCurrentPageIndex };
};
